import { DefaultAPI } from "app/services/default";
import { config } from "app/config";

export async function apiCall(fn: ((...params: any) => any), ...args: any[]): Promise<any> {
    const response = await fn(...args);
    if (response.status === 200) return await response.json();
    throw response;
}

export const defaultApi: DefaultAPI = new DefaultAPI(config.api ? config.api.default.url : "");
